import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '~/common/components/Buttons/Button/index';
import Text from '~/common/components/Texts/Text';
import theme from '~/theme/';

type QuestionLibraryButtonProps = {
  handleClick: (...args: any[]) => any;
  label: string;
  testId?: string;
  isDisabled?: boolean;
  icon?: any;
  fontColor?: string;
  backgroundColor?: string;
  sx?: any;
  variant?: string;
  ariaLabel?: string;
};

export default function QuestionLibraryButton({
  handleClick,
  icon,
  label = 'Add',
  fontColor = theme.colors?.blue[600],
  backgroundColor = 'none',
  testId = 'question-library-button',
  isDisabled = false,
  sx = {},
  variant,
  ariaLabel,
}: Readonly<QuestionLibraryButtonProps>) {
  return (
    <Button
      type="button"
      background={backgroundColor}
      color={fontColor}
      onClick={() => handleClick()}
      isDisabled={isDisabled}
      data-testid={testId}
      sx={sx}
      variant={variant}
      aria-label={ariaLabel}
    >
      {icon && <FontAwesomeIcon icon={icon} color={fontColor} />}
      {label && (
        <Text marginLeft={icon ? '0.5rem' : '0'} color={fontColor}>
          {label}
        </Text>
      )}
    </Button>
  );
}
